import React from 'react'

import SettingsPage from '../SettingsPage'
import IntegrationsTable from './IntegrationsTable'

const IntegrationSettings = () => (
  <SettingsPage title='Integrations'>
    <IntegrationsTable />
  </SettingsPage>
)

export default IntegrationSettings
